import { renderDateFormated } from "../../utils";

  export const columnsAssemble: any = [
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Contato",
      dataIndex: "contact",
      key: "contact",
      sorter: (a: any, b: any) =>
        a.contact ? a.contact.localeCompare(b.contact) : "",
    },
    {
      title: "Inclusão",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: any) =>
        date ? renderDateFormated(date, false, true) : "",
    },
    {
      title: "Agendamento",
      dataIndex: "start",
      key: "start",
      sorter: (a: any, b: any) =>
        new Date(a.start).getTime() - new Date(b.start).getTime(),
      render: (date: any) =>
        date ? renderDateFormated(date, false, true) : "",
    },
    {
      title: "Situação",
      dataIndex: "status",
      key: "status",
      sorter: (a: any, b: any) =>
        a.status ? a.status.localeCompare(b.status) : "",
    },
    {
      title: "Data Envio Montagem",
      dataIndex: "sentToApp",
      key: "sentToApp",
      sorter: (a: any, b: any) => a.sentToApp > b.sentToApp,
      render: (date: string): string =>
        date ? renderDateFormated(date, false, false) : "",
    },
    {
      title: "Data Preenchimento",
      dataIndex: "filledAt",
      key: "filledAt",
      sorter: (a: any, b: any) => {
        return new Date(a.filledAt).getTime() - new Date(b.filledAt).getTime();
      },
      render: (date: string): string =>
        date ? renderDateFormated(date, false, false) : "",
    },
    {
      title: "Montador",
      dataIndex: "owner",
      key: "owner",
      sorter: (a: any, b: any) =>
        a.owner ? a.owner.localeCompare(b.owner) : "",
    },

    {
      title: "Valor",
      dataIndex: "totalValue",
      key: "totalValue",
      sorter: (a: any, b: any) =>
        a.totalValue ? a.totalValue.localeCompare(b.totalValue) : "",
      render: (value: any) => value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    },
  ];